<template>
  <router-view v-slot="{ Component }">
    <transition name="page-transition" mode="out-in">
      <keep-alive v-if="isKeep">
        <component :is="Component" />
      </keep-alive>
      <component :is="Component" v-else/>
    </transition>
  </router-view>
</template>
<script>
export default {
  name: 'RouteView',
  props: {
    keepAlive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    isKeep() {
      const { $route: { meta }, $store: { getters } } = this
      // 这里增加了 multiTab 的判断，当开启了 multiTab 时
      // 应当全部组件皆缓存，否则会导致切换页面后页面还原成原始状态
      // 若确实不需要，可改为 return meta.keepAlive ? inKeep : notKeep
      if (!getters.multiTab && !meta.keepAlive) {
        return false
      }
      return this.keepAlive || getters.multiTab || meta.keepAlive ? true : false
    }
  }
}
</script>
